import React from "react";
import { Formik, Form } from "formik";
// import * as Yup from "yup";
import { CircularProgress } from "@material-ui/core";
import Button from "../../../../ui/components/Button";
import { MappedInput } from "../../../../ui/components/Input";
import SimpleCheckbox from "./SimpleCheckbox";
import PostCodeInputMapped from "./PostCodeInput";

// const validationSchema = Yup.object({
//   excludeChallenge: Yup.boolean(),
//   excludeImport: Yup.boolean(),
//   percentageCriteria: Yup.number()
//     .nullable()
//     .required("Percentage criteria is required")
//     .min(0, "Percentage must be positive")
//     .max(100, "Percentage cannot exceed 100"),
//   excludePostCodes: Yup.array(),
// });

const CommodityReportStep2 = (props) => {
  const { prevStepValues, onBack, onSubmit, loading } = props;

  const initialValues = {
    excludeChallenge: false,
    excludeImport: false,
    percentageCriteria: 50,
    excludePostCodes: [],
  };

  const handleSubmit = (values) => {
    const combinedValues = {
      ...prevStepValues,
      ...values,
    };

    onSubmit(combinedValues);
  };

  return (
    <>
      <h4>
        <strong>Commodity and Detection Report</strong>
      </h4>
      <hr />

      <Formik
        initialValues={initialValues}
        // validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          touched,
          isSubmitting,
          isValid,
          values,
          setFieldValue,
        }) => (
          <Form>
            <div className="mb-4">
              <h6 className="mb-3">Other Criteria</h6>

              <MappedInput
                name="percentageCriteria"
                label="+MRL/ML Percentage Criteria"
                size="small"
                color="#71BF44"
                background="#f5f5f5"
                type="number"
                placeholder="0.00"
                inputProps={{
                  step: "0.01",
                  min: "0",
                  max: "100",
                }}
                inputWrapperStyle={{
                  width: "250px",
                }}
              />

              <SimpleCheckbox
                name="excludeChallenge"
                label="Exclude Challenge Tests"
              />
            </div>

            <div className="mb-4">
              <h6 className="mb-3">Overseas Product</h6>

              <SimpleCheckbox
                name="excludeImport"
                label="Exclude if 'Import' is found in the customer ref. field"
              />
            </div>

            <div className="w-50">
              <PostCodeInputMapped
                name="excludePostCodes"
                label="Exclude Post Codes"
                color="#71BF44"
                background="#f5f5f5"
                disabled={loading}
              />
            </div>

            <div className="d-flex justify-content-between mt-8">
              <Button
                type="button"
                label="Back"
                text="light"
                background="transparent"
                onClick={onBack}
                disabled={loading}
                className="ml-auto mr-8 text-uppercase"
              />
              <Button
                type="submit"
                label={loading ? "Generating Report..." : "Generate Report"}
                text="#FFFFFF"
                background="#71BF44"
                boxShadow
                disabled={isSubmitting || loading}
                icon={
                  loading ? (
                    <CircularProgress
                      size={20}
                      color="inherit"
                      className="mr-2"
                    />
                  ) : null
                }
                className="text-uppercase"
              />
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default CommodityReportStep2;
